import React, { useState, useEffect } from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import Home from "../Home/";
import Wallet from "../Wallet";
import Exchange from "../Exchange";
import MarketplaceCategories from "../MarketplaceCategories";
import AsyncStorage from "@react-native-async-storage/async-storage";

import styles from "./style";

const Tabs = ({ navigation, route }) => {
  const [activeTab, setActiveTab] = useState(1);

  const [openTransaction, setOpenTransaction] = useState(route?.params?.openTransaction);

  function handleTab(id) {
    setActiveTab(id);
  }

  useEffect(() => {
    handleStorageCommands();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setOpenTransaction(false);
      console.log('clear open transaction');
    }, 4000);
  }, [openTransaction]);

  useEffect(() => {
    if (route?.params?.openTransaction) {
      setOpenTransaction(route?.params?.openTransaction);
      handleTab(4);
    }
  }, [route.params]);

  const handleStorageCommands = async () => {
    AsyncStorage.getItem('navigate_tabs').then(async (response) => {
      console.log('AsyncStorage', response);
      if (response?.length > 0 && response === 'wallet') {
        setActiveTab(4);
      }
      await AsyncStorage.setItem('navigate_tabs', '');
    });
  }

  return (
    <>
      {activeTab === 1 ? (
        <Home />
      ) : activeTab === 2 ? (
        <MarketplaceCategories navigation={navigation} />
      ) : activeTab === 3 ? (
        <Exchange navigation={navigation} />
      ) : activeTab === 4 ? (
        <Wallet openTransaction={openTransaction} />
      ) : (
        <></>
      )}
      <View style={styles.container}>
        <View style={styles.content}>
          <TouchableOpacity style={styles.tab} onPress={() => handleTab(1)}>
            {activeTab === 1 ? (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/home_active.png")}
                  style={{ width: 28, height: 28 }}
                /> */}
                <Text style={styles.labelActive}>Home</Text>
              </>
            ) : (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/home.png")}
                  style={{ width: 28, height: 28 }}
                /> */}
                <Text style={styles.label}>Home</Text>
              </>
            )}
          </TouchableOpacity>
          <TouchableOpacity style={styles.tab} onPress={() => handleTab(2)}>
            {activeTab === 2 ? (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/marketplace_active.png")}
                  style={{ width: 28, height: 28 }}
                /> */}
                <Text style={styles.labelActive}>Marketplace</Text>
              </>
            ) : (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/marketplace.png")}
                  style={{ width: 31, height: 28 }}
                /> */}
                <Text style={styles.label}>Marketplace</Text>
              </>
            )}
          </TouchableOpacity>
          <TouchableOpacity style={styles.tab} onPress={() => handleTab(3)}>
            {activeTab === 3 ? (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/exchange_active.png")}
                  style={{ width: 28, height: 28 }}
                /> */}
                <Text style={styles.labelActive}>Exchange</Text>
              </>
            ) : (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/exchange.png")}
                  style={{ width: 31, height: 28 }}
                /> */}
                <Text style={styles.label}>Exchange</Text>
              </>
            )}
          </TouchableOpacity>
          <TouchableOpacity style={styles.tab} onPress={() => handleTab(4)}>
            {activeTab === 4 ? (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/carteira_active.png")}
                  style={{ width: 31, height: 28 }}
                /> */}
                <Text style={styles.labelActive}>Carteira</Text>
              </>
            ) : (
              <>
                {/* <Image
                  source={require("../../../assets/tabs/icons/carteira.png")}
                  style={{ width: 31, height: 28 }}
                /> */}
                <Text style={styles.label}>Carteira</Text>
              </>
            )}
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

export default Tabs;
